import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IAboutUsDetail, IAboutUsSearchFields, aboutUsService, IAboutUsFormFields, IAboutUsInsert, IAboutUsUpdate } from "./aboutUsService";
import { transPgToPagination } from "@/model/globalModel";
import { ISearchPage } from "@/types/AppTypes";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM, defaultMdCmParam } from "@/utils/constants";
import { globalPrompt } from "@/components/message";

interface IAboutUsDrawerType {
    visible: boolean,
    mode: "add" | "edit" | "look"
}

export const useAboutUsModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<IAboutUsDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IAboutUsSearchFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

    //列表查询
    const loadData = async (page?: ISearchPage, searchValue: IAboutUsSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            // sourceApp: defaultMdCmParam.sourceApp,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await aboutUsService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IAboutUsSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    /**
     * 详情
     */
    const initAboutUsDrawer: IAboutUsDrawerType = { visible: false, mode: "add" }
    const [aboutUsDrawer, setAboutUsDrawer] = useState<IAboutUsDrawerType>(initAboutUsDrawer);
    const setIAboutUsDrawer = (str?: "add" | "edit" | "look") => setAboutUsDrawer(str ? { visible: true, mode: str } : initAboutUsDrawer);

    //根据id查询
    const getSelectedRowData = () => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        return filters && filters.length > 0 ? { ...filters[0] } : {};
    };

    const insertAboutUs = async (val: IAboutUsInsert) => {
        let { retData } = await aboutUsService.insert(val);
        if (retData) {
            loadData();
            setIAboutUsDrawer();
            globalPrompt("message", { text: "新增成功", type: "success" })
        } else {
            globalPrompt("message", { text: "新增失败", type: "error" });
        }
    }

    //编辑
    const editAboutUs = async (val: IAboutUsInsert) => {
        let { retData } = await aboutUsService.update({ ...val, id: selectedRowKeys[0] });
        if (retData) {
            loadData();
            setIAboutUsDrawer();
            globalPrompt("message", { text: "修改成功", type: "success" })
        } else {
            globalPrompt("message", { text: "修改失败", type: "error" });
        }
    }

    //启用 禁用 api
    const disableAboutUs = async (id: string) => {
        let { retData } = await aboutUsService.disable(id);
        loadData();
        globalPrompt("message", { text: "操作成功", type: "success" })
    };

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        /***method***/
        aboutUsDrawer, setIAboutUsDrawer,
        getSelectedRowData,
        insertAboutUs,
        editAboutUs,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        disableAboutUs,
    }
});